import React from 'react'
import { FormLabel, FormControl, FormGroup, FormText } from 'react-bootstrap'

const TextFieldFormGroup = ({
  controlId,
  validationState,
  controlLabel,
  value,
  handleFieldChange,
  help,
  placeholder,
  name,
  disabled,
  ...rest
}) => {
  return (
    <FormGroup controlId={controlId}>
      <FormLabel>{controlLabel}</FormLabel>
      <FormControl
        isInvalid={validationState === 'error'}
        placeholder={placeholder}
        type='text'
        value={value}
        onChange={handleFieldChange}
        name={name}
        disabled={disabled}
        {...rest}
      />
      <FormControl.Feedback />
      <FormText className='small'>
        <em>{help}</em>
      </FormText>
    </FormGroup>
  )
}

export default TextFieldFormGroup
